import React, { PropsWithChildren, createRef, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { ShowFitAssistantSelector } from '../../Selectors/FitAssistantSelectors.ts';
import Header from '../Header/Header.tsx';

import './ModalContent.less';
import { tabable } from '/Foundation/Common/code/Utils/WcagUtils.js';
import { setShowFitAssistant, setShowMoreInfo } from '../../Slices/FitAssistantSlice';
import { Constants } from '../../Constants.ts';

const ModalContent = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();
  const showFitAssistant = useAppSelector(ShowFitAssistantSelector);
  const modalbodyRef = createRef<HTMLDivElement>();
  const previouslyFocused = useRef<HTMLElement | null>(null);

  useEffect(() => {
    modalbodyRef?.current?.scrollTo(0, 0);
  }, [children]);

  const onFocusChangeFocusTo = (query: string, firstElement = false) => {
    const elements = document.querySelectorAll<HTMLElement>(query);
    if (firstElement) elements[0]?.focus();
    else {
      elements[elements.length - 1]?.focus();
    }
  };

  useEffect(() => {
    if (showFitAssistant) {
      previouslyFocused.current = document.activeElement as HTMLElement;
      onFocusChangeFocusTo(Constants.WCAG.FIRST_TABABLE, true);
    } else {
      previouslyFocused.current?.focus?.();
    }
  }, [showFitAssistant]);

  const closeKeyHandler = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      dispatch(setShowFitAssistant(false));
      dispatch(setShowMoreInfo(false));
    }
  };
  return (
    <>
      <div
        className={`fit-assistant-modal on-top ${showFitAssistant ? 'wrapper-visible' : ''}`}
        aria-modal={showFitAssistant ? 'true' : null}
        role="dialog"
        onKeyUp={(e) => closeKeyHandler(e)}
      >
        <div
          tabIndex={tabable(showFitAssistant)}
          onFocus={() => onFocusChangeFocusTo(Constants.WCAG.LAST_TABABLE)}
        ></div>
        <header>
          <Header />
        </header>
        <section className="modal-content-section position-relative d-inline-block h-100" ref={modalbodyRef}>
          <div className="fit-assistant-modal-body">{children}</div>
        </section>
        <div id="moreInfoPortal"></div>
        <div id="buttonPortal"></div>
        <div
          tabIndex={tabable(showFitAssistant)}
          onFocus={() => onFocusChangeFocusTo(Constants.WCAG.FIRST_TABABLE, true)}
        ></div>
      </div>
    </>
  );
};

export default ModalContent;
